/*
**************************** 
홈페이지 런처 구매 리스트
*****************************
*/

import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { MyContext } from "../App";
import "../css/Pagination.scss";
import BuyOrderSub from "./BuyOrderSub";

export default function BuyOrder(props) {
    const { choiceValue, setValue } = useContext(MyContext);

    const [buyAmount, SetBuyAmount] = useState(1);

    // const PAY_URL = "https://bs-l4box.com/payment";
    // const PAY_URL = "http://13.125.167.77/payment"; //dev
    // const PAY_URL = "http://localhost:5000/payment"; //local
    const PAY_URL = "/buy/payment";
    const [userData, setUserData] = useState({ userName: "", phone: "" });
    const [proData, setProData] = useState({});
    const [totalAmount, setTotalAmount] = useState(0);
    const [color, setColor] = useState("선택");

    const addAmount = () => {
        SetBuyAmount(buyAmount + 1);
        totalProductPrice();
    }

    const minusAmount = () => {
        if (buyAmount - 1 > 0) {
            SetBuyAmount(buyAmount - 1);
        }
        totalProductPrice();
    }

    const totalProductPrice = () => {
        let defaultPrice = props.data.price;
        if (props.data.discount_on_off == 1) {
            defaultPrice = props.data.discount;
        }

        const delivery = 0;
        const sumPrice = defaultPrice * buyAmount + delivery;

        setTotalAmount(sumPrice);
    }

    const req = async function (userId) {
        const reqSql = "/api/users/user/" + userId;
        await axios.get(reqSql, { 'Content-Type': 'application/json', withCredentials: true }).then(function (res) {

            if (res.data.length > 0) {
                const user = res.data[0];
                let copyUserData = {
                    ...userData, user_id: user.id, username: user.username, name: user.name, email: user.email, phone: user.phone, address: user.address, subAddress: user.sub_address, password: user.pass
                };
                setUserData(copyUserData);
            } else {
                if (res.status === 400) {
                    alert("세션 만료 로그인이 필요합니다.");
                } else {
                    alert("데이터 가져오는 도중 오류가 발생하였습니다.");
                }
            }
        }).catch(function (err) {
            console.log(err);
            if (err.code === "ERR_BAD_REQUEST") {
                alert("세션 만료 로그인이 필요합니다.");
            } else {
                alert("데이터 가져오는 도중 오류가 발생하였습니다.");
            }
        });
    }

    useEffect(() => {
        const id = sessionStorage.getItem("userId");
        if (Number(id) !== -1 && id !== null) {
            req(id);
        }

    }, []);

    useEffect(() => {
        totalProductPrice();
    })

    useEffect(() => {
        let copyUserData = {
            ...userData, username: props.user.username, name: props.user.name, email: props.user.email, phone: props.user.phone, address: props.user.address, subAddress: props.user.sub_address, password: props.user.pass
        };
        setUserData(copyUserData);

        const productColorArr = props.data.product_color;
        let copyProdata = {
            ...proData, product_id: props.data.id, product: props.data.product, price: props.data.price, delivery: props.data.delivery, discount: props.data.discount, point: props.data.point, product_key: props.data.product_key, product_type: props.data.product_type,
            use_type: props.data.use_type, product_color: productColorArr != undefined && productColorArr != null ? productColorArr.toString().split(",") : ""
        };
        setProData(copyProdata);

    }, [props.data.product]);

    const confirmService = useRef(false);
    const confirmPrivate = useRef(false);
    const confirmEventshop = useRef(false);
    const confirmOthershop = useRef(false);
    const confirmeCommerce = useRef(false);
    const confirmAge = useRef(false);

    const submitOrder = (event) => {
        event.preventDefault();

        if (confirmService.current === true && confirmeCommerce.current === true) {
            const sumAddr = userData.address + " " + userData.subAddress;

            const productDataUri = PAY_URL;
            window.open("", "openForm", "scrollbars=no, location=no, toolbar=no, menubar=no, resizable=no, titlebar=no,  copyhistory=no, width=1000, height=700");

            var datas_param = [["product_id", proData.product_id], ["user_id", userData.user_id], ["sumAddr", sumAddr], ["goodsName", proData.product],
            ["amt", proData.price], ["buyerName", userData.username], ["buyerEmail", userData.email], ["buyerTel", userData.phone],
            ["confirmeCommerce", confirmeCommerce.current], ["confirmService", confirmService.current], ["confirmPrivate", confirmPrivate.current], ["confirmEventshop", confirmEventshop.current], ["confirmOthershop", confirmOthershop.current], ["confirmAge", confirmAge.current],
            ["target_userName", event.target.target_userName.value], ["target_address", event.target.target_address.value], ["target_subAddress", event.target.target_subAddress.value],
            ["target_phone", event.target.target_phone.value], ["reqOrder", event.target.reqOrder.value], ["reqReserved", proData.product_type], ["productColor", event.target.product_color.value], ["use_type", proData.use_type]
            ];

            var f = document.createElement("form"); // form 엘리멘트 생성 
            f.setAttribute("target", "openForm"); // method 속성을 post로 설정
            f.setAttribute("method", "post"); // method 속성을 post로 설정
            f.setAttribute("action", productDataUri); // submit했을 때 무슨 동작을 할 것인지 설정
            document.body.appendChild(f); // 현재 페이지에 form 엘리멘트 추가 
            for (var i = 0; i < datas_param.length; i++) {
                var data_param = datas_param[i];
                var name = data_param[0];
                var value = data_param[1];
                var it = document.createElement("input"); // input 엘리멘트 생성 
                it.setAttribute("type", "hidden"); // type 속성을 hidden으로 설정
                it.setAttribute("name", name); // name 속성을 'm_nickname'으로 설정
                it.setAttribute("value", value); // name 속성을 'm_nickname'으로 
                f.appendChild(it); // form 엘리멘트에 input 엘리멘트 추가 
            }

            f.submit(); // form 태그 서브밋 실행
        }
    }

    return (
        <div>
            <div>
                <div className="modal fade" id={props.data.product_key + '_' + props.data.id} data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title fw-bold" id="exampleModalLabel">톡톡박스구매하기</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {
                                    window.location.href = "/BuyTocTocBox";
                                }}></button>
                            </div>
                            <div className="modal-body">
                                <div className="sign-in">
                                    <form onSubmit={submitOrder} >
                                        <div className="row">
                                            <div className="col-6 my-3">
                                                <div className="card">
                                                    <div id={"carouselExampleIndicators" + '_' + props.data.id} className="carousel slide carousel-fade">

                                                        <div className="carousel-inner">
                                                            <div className="carousel-item active">
                                                                <img src={props.data.product_thum_image} className="d-block w-100" alt="..."></img>
                                                            </div>
                                                            {props.data.product_thum_image1 != null && props.data.product_thum_image1 != undefined ?
                                                                <div className="carousel-item">
                                                                    <img src={props.data.product_thum_image1} className="d-block w-100" alt="..."></img>
                                                                </div> : null}
                                                            {props.data.product_thum_image2 != null && props.data.product_thum_image2 != undefined ?
                                                                <div className="carousel-item">
                                                                    <img src={props.data.product_thum_image2} className="d-block w-100" alt="..."></img>
                                                                </div> : null}
                                                            {props.data.product_thum_image3 != null && props.data.product_thum_image3 != undefined ?
                                                                <div className="carousel-item">
                                                                    <img src={props.data.product_thum_image3} className="d-block w-100" alt="..."></img>
                                                                </div> : null}
                                                            {props.data.product_thum_image4 != null && props.data.product_thum_image4 != undefined ?
                                                                <div className="carousel-item">
                                                                    <img src={props.data.product_thum_image4} className="d-block w-100" alt="..."></img>
                                                                </div> : null}
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="carousel-indicators">
                                                </div>
                                                <div className="text-start mt-1">
                                                    <img src={props.data.product_thum_image} data-bs-target={"#carouselExampleIndicators" + '_' + props.data.id} data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1" style={{ width: '60px', margin: "2px" }}></img>
                                                    {props.data.product_thum_image1 != undefined && props.data.product_thum_image1 != null ? <img src={props.data.product_thum_image1} data-bs-target={"#carouselExampleIndicators" + '_' + props.data.id} data-bs-slide-to="1" className="active" aria-current="true" aria-label="Slide 2" style={{ width: '60px', margin: "2px" }} ></img> : null}
                                                    {props.data.product_thum_image2 != undefined && props.data.product_thum_image2 != null ? <img src={props.data.product_thum_image2} data-bs-target={"#carouselExampleIndicators" + '_' + props.data.id} data-bs-slide-to="2" className="active" aria-current="true" aria-label="Slide 3" style={{ width: '60px', margin: "2px" }}></img> : null}
                                                    {props.data.product_thum_image3 != undefined && props.data.product_thum_image3 != null ? <img src={props.data.product_thum_image3} data-bs-target={"#carouselExampleIndicators" + '_' + props.data.id} data-bs-slide-to="3" className="active" aria-current="true" aria-label="Slide 4" style={{ width: '60px', margin: "2px" }}></img> : null}
                                                    {props.data.product_thum_image4 != undefined && props.data.product_thum_image4 != null ? <img src={props.data.product_thum_image4} data-bs-target={"#carouselExampleIndicators" + '_' + props.data.id} data-bs-slide-to="4" className="active" aria-current="true" aria-label="Slide 5" style={{ width: '60px', margin: "2px" }}></img> : null}
                                                </div>
                                            </div>
                                            <div className="col-6 my-3 ">
                                                <h6 className="col text-start fs-5 fw-bolder " >{props.data.product}
                                                    {props.data.discount_on_off == 1 ? <span className="badge bg-danger card-badge text-uppercase ms-2" style={{ fontSize: "12px" }}>Sale</span> : null}
                                                </h6>

                                                <h6 className="col text-start fs-6 fw-bolder " >{props.data.discount_on_off == 1 ? props.data.discount.toLocaleString() : props.data.price.toLocaleString()}원
                                                    {props.data.discount_on_off == 1 ? <span className="text-decoration-line-through p-2" style={{ fontSize: '12px', verticalAlign: "top" }}>{(props.data.price).toLocaleString()}원</span> : null}
                                                </h6>
                                                <hr className="mt-2 mb-3"></hr>

                                                <h6 className="col text-start mt-2" style={{ fontSize: "14px", fontWeight: "bolder" }}>배송 방법 <span style={{ fontSize: "14px", fontWeight: "normal" }}>{props.data.delivery_method}</span></h6>
                                                <h6 className="col text-start" style={{ fontSize: "14px", fontWeight: "bolder" }}>배송비 <span style={{ fontSize: "14px", fontWeight: "normal" }}>{props.data.delivery.toLocaleString()}원</span></h6>
                                                <h6 className="col text-start" style={{ fontSize: "14px", fontWeight: "bolder" }}>배송 안내 <span style={{ fontSize: "14px", fontWeight: "normal" }}>{props.data.delivery_anounce}</span></h6>

                                                <h6 className="col text-start  fs-6 fw-bolder mt-4" >제품 색상</h6>

                                                <select className="form-select " name="product_color" onChange={(e) => {
                                                    setColor(e.target.options[e.target.selectedIndex].value);
                                                }} >
                                                    <option defaultChecked={true}>선택</option>
                                                    {props.data.product_color != undefined && props.data.product_color.length > 0 ? props.data.product_color.toString().split(",").map((cell, idx) => {
                                                        return (
                                                            <option key={idx} value={cell}>{cell}</option>
                                                        )
                                                    }) : null}
                                                </select>

                                                <div className="pagibox mt-2">
                                                    <h6 className="col text-start p-2 border-bottom" style={{ fontSize: "14px" }} >수량</h6>
                                                    <div className="row">
                                                        <div className="pagi col-6">
                                                            <button className="countbox" onClick={minusAmount}>
                                                                -
                                                            </button>
                                                            <div className="mid">
                                                                {buyAmount}
                                                            </div>
                                                            <button className="countbox" onClick={addAmount}>
                                                                +
                                                            </button>
                                                        </div>
                                                        <div className="col-6 d-flex align-items-center d-flex justify-content-end ">
                                                            <h6 className="me-2">{totalAmount.toLocaleString()}원</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row mt-4">
                                                    <h6 className="col text-start fs-6 " >총 상품금액</h6>
                                                    <h6 className="col text-end fs-6 " >{totalAmount.toLocaleString()}원</h6>
                                                </div>
                                                {sessionStorage.getItem("state") == "true" ?
                                                    <button type="button" className="w-100 btn btn-info mt-3 " onClick={function () {
                                                        if (color === "선택") {
                                                            alert("제품 색상을 선택하세요.")
                                                        } else {
                                                            const id = sessionStorage.getItem("userId");
                                                            setValue({ ...choiceValue, userId: id, amount: totalAmount, productColor: color, productAmount: buyAmount });
                                                            sessionStorage.setItem("buyType", props.data.product_key + '_' + props.data.id + "_sub");
                                                            sessionStorage.setItem("buyTarget", "BuyTocTocBox");

                                                            window.closeBuyTocTocBox(props.data.product_key + '_' + props.data.id);
                                                            window.buyProcess();
                                                        }
                                                    }}>구매하기</button> : <button type="button" className="w-100 btn btn-info mt-3" onClick={function () {
                                                        if (color === "선택") {
                                                            alert("제품 색상을 선택하세요.")
                                                        } else {
                                                            const id = sessionStorage.getItem("userId");
                                                            setValue({ ...choiceValue, userId: id, amount: totalAmount, productColor: color, productAmount: buyAmount });
                                                            sessionStorage.setItem("buyType", props.data.product_key + '_' + props.data.id + "_sub");
                                                            sessionStorage.setItem("buyTarget", "BuyTocTocBox");

                                                            window.closeBuyTocTocBox(props.data.product_key + '_' + props.data.id);
                                                            window.buyAlertlogin();
                                                        }
                                                    }}>구매하기</button>}
                                            </div>
                                        </div>
                                        <hr className="mt-4 mb-4"></hr>
                                        <div>
                                            <img className="w-100" src={props.data.product_detail_image}></img>
                                            <img className="w-100" src={props.data.product_detail_image1}></img>
                                            <img className="w-100" src={props.data.product_detail_image2}></img>
                                        </div>
                                        <div className="form-group mt-4 row p-2">
                                            <img className="w-100" src={props.data.notice1_image}></img>
                                        </div>
                                        <div className="form-group mt-4 row p-2">
                                            <img className="w-100" src={props.data.notice2_image}></img>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <BuyOrderSub data={props.data} user={userData}></BuyOrderSub>
        </div>
    )
}